import React from 'react';
import { object, func, string } from 'prop-types';
import { get, map, head, includes, size, find, filter, toString } from 'lodash';
import moment from 'moment';
import { withApollo } from 'react-apollo';
import { FormSelect, FlexContainer, Text, FormDatePicker, FormInput, SalesChannelSelect } from '../../common';
import { Query } from '../../graphql';
import { GET_SCHEDULE_WINDOW } from '../../../queries';
import { disabledShippingDates } from '../../../utils/misc';

const NewShippingMassive = ({
    onChangeComments,
    shippingStore,
    onChangeShippingDate,
    shippingTime,
    onChangeShippingTime,
    shippingDate,
    setShippingStore,
    logisticsInfo,
    salesChannel
}) => {
    const fieldErrors = (type) => {
        switch (type) {
        case 'shippingStore':
            return 'Temporalmente sin cobertura, intenta con otra dirección';
        case 'shippingStore-scheduling':
            return 'Temporamente sin cobertura, intenta con otro Tipo de envío';
        case 'shippingTime':
            return 'No hay ventanas disponibles para ésta fecha seleccionada.';
        default:
            return 'Error.';
        }
    };

    const remoteStore = () => (<SalesChannelSelect
        native
        label='Tienda'
        salesChannel={salesChannel}
        onCompleted={({ value, data }) => {
            const defaultSalesChannelData = find(data, ({ id }) => includes([get(value, 'value')], id));
            setShippingStore({
                label: get(value, 'label'),
                value: get(value, 'value'),
                data: {
                    title: get(value, 'label'),
                    id: get(defaultSalesChannelData, 'store'),
                    comercial_policy: parseInt(get(value, 'value')),
                    slaType: 'Despacho'
                }
            });
        }}
        onChange={({ value, data }) => setShippingStore({
            label: get(value, 'label'),
            value: get(value, 'value'),
            data: {
                title: get(value, 'label'),
                id: get(data, 'store'),
                comercial_policy: parseInt(get(value, 'value')),
                slaType: 'Despacho'
            }
        })}
    />);

    const shippingDateBox = () => (<FormDatePicker
        style={{ minWidth: '100%' }}
        label='Nueva fecha de envío'
        defaultValue={moment()}
        showDateInput={false}
        disabledDate={disabledShippingDates}
        portalStyle={{ position: 'absolute', zIndex: 1, top: '5px' }}
        onChange={values => onChangeShippingDate(values)}
    />);

    const scheludeWindow = () => {
        const slaType = get(logisticsInfo, 'selectedSla');
        const store = get(shippingStore, 'data.id', null);

        if (!slaType || !store || !shippingDate) return null;

        const newDate = toString(head(shippingDate).day());

        return (<Query query={GET_SCHEDULE_WINDOW} variables={{ newDate, slaType, store }}>
            {({ data, loading }) => {
                const windows = get(data, 'getScheduleWindow', []);
                const shippingTimeOptions = map(windows, ({ window, id, ...fields }) => {
                    return { label: window, value: id, ...fields };
                });

                return (<FormSelect
                    label='Nuevo horario'
                    value={shippingTime}
                    options={shippingTimeOptions}
                    onChange={({ value }) => {
                        const timeValue = get(value, 'label', moment().format('HH:mm'));
                        const timeProperties = head(filter(shippingTimeOptions, ({ value: optionId }) => optionId === get(value, 'value', 1)));
                        onChangeShippingTime({ ...timeProperties, label: timeValue, value: get(timeProperties, 'fullWindow') });
                    }}
                    loading={loading}
                    error={size(shippingTimeOptions) < 1 && fieldErrors('shippingTime')}
                />);
            }}
        </Query>);
    };

    return (
        <FlexContainer mY={15} direction='column'>
            <Text semibold size={13} text='Nueva información de envío' />
            { remoteStore() }
            { shippingDateBox() }
            { scheludeWindow() }
            <FormInput
                label='Motivo'
                textArea
                onChange={event => onChangeComments(get(event, 'target.value', null))}
            />
        </FlexContainer>
    );
};

NewShippingMassive.propTypes = {
    shippingDate: string,
    onChangeShippingDate: func,
    onChangeComments: func,
    shippingStore: object,
    setShippingStore: func,
    shippingTime: object,
    onChangeShippingTime: func,
    logisticsInfo: object,
    salesChannel: object
};

export default withApollo(NewShippingMassive);
